import api from "../../client";
import {
  CreateCampusActivityPayload,
  CreateCampusActivityResponseData,
} from "../../types/enum";

export const createCampusActivityRequest = async (
  payload: CreateCampusActivityPayload,
) => {
  const { data } = await api.post<CreateCampusActivityResponseData>(
    `/campus-activity`,
    payload,
  );

  return data;
};
